"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _constants = require("../constants");

var _Divider = _interopRequireDefault(require("./Divider.style"));

var _dec, _class;

let Divider = (_dec = (0, _reactJss.default)(_Divider.default), _dec(_class = class Divider extends _react.PureComponent {
  render() {
    const _this$props = this.props,
          {
      classes,
      orientation,
      color,
      className,
      dataTestId
    } = _this$props,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "orientation", "color", "className", "dataTestId"]);
    return /*#__PURE__*/_react.default.createElement("hr", (0, _extends2.default)({
      className: (0, _clsx.default)(className, classes.divider, orientation, classes[`backgroundColor__${color}`]),
      "data-testid": dataTestId
    }, props));
  }

}) || _class);
Divider.ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
Divider.defaultProps = {
  orientation: Divider.ORIENTATION.vertical
};
Divider.COLOR = _constants.COLOR;
var _default = Divider;
exports.default = _default;